import {useToggle} from '@yandex-delivery/hooks'
import {memo} from 'react'

import {Paper} from '../../../../../../components/ui'
import {Map} from '../../../Map/Map'
import {FullScreenPolygonMap} from '../FullScreenMap/FullScreenPolygonMap/FullScreenPolygonMap@desktop'
import styleClasses from './classes@desktop.module.css'
import {arePropsEqual} from './lib'
import type {Props} from './model'

export const CargoMapContainer = memo<Props>(({polygon}) => {
  const [modalOpened, toggleModalOpened] = useToggle(false)

  return (
    <>
      <Paper className={styleClasses.mapPaperStyled}>
        <Map onFullSize={toggleModalOpened} polygon={polygon} />
      </Paper>
      <FullScreenPolygonMap onBack={toggleModalOpened} opened={modalOpened} polygon={polygon} />
    </>
  )
}, arePropsEqual)
